import { oz } from '@weft/utils';
import { CustomerSchema } from '../../customer';

export const AnonymousCustomersReportSchema = oz.object({
  customers: CustomerSchema.array(),
  count: oz.number().nonnegative(),
});

export type AnonymousCustomersReport = oz.infer<typeof AnonymousCustomersReportSchema>;